import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  referralCode: string;
};

const LoginPromocodeReferral = (props: Props) => {
  const { referralCode } = props;
  const { t } = useTranslation();

  return (
    <div className="login-referral-intro">
      <img className="login-referral-intro-img" alt="gift confetti" src="/images/gift-confetti-white.png" />
      <h2>{t('components.login.referral-headline')}</h2>
      <p>
        <Trans i18nKey="components.login.referral-description" values={{ referralCode: referralCode.toUpperCase() }} />
      </p>
      <p className="small">{t('components.login.referral-disclaimer')}</p>
    </div>
  );
};

export default LoginPromocodeReferral;
